import React, { useState } from 'react'
    import { Mail, Phone, MapPin, Send } from 'lucide-react'
    import toast from 'react-hot-toast'

    const Contact = () => {
      const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
      })

      const handleChange = (e) => {
        setFormData({
          ...formData,
          [e.target.name]: e.target.value
        })
      }

      const handleSubmit = (e) => {
        e.preventDefault()
        // Simulate form submission
        toast.success('Message sent successfully! We\'ll get back to you soon.')
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        })
      }

      const contactInfo = [
        {
          icon: <Mail className="h-6 w-6 text-blue-500" />,
          title: 'Email',
          details: 'hello@modernapp.com',
          link: 'mailto:hello@modernapp.com'
        },
        {
          icon: <Phone className="h-6 w-6 text-green-500" />,
          title: 'Phone',
          details: '+1 (555) 123-4567',
          link: 'tel:+15551234567'
        },
        {
          icon: <MapPin className="h-6 w-6 text-red-500" />,
          title: 'Address',
          details: '123 Innovation Street, Tech City, TC 12345',
          link: '#'
        }
      ]

      return (
        <div className="min-h-screen bg-gray-50" data-component-path="client/src/pages/Contact.jsx" data-component-line="1:4" data-component-id="client/src/pages/Contact.jsx:1:4">
          {/* Hero Section */}
          <section 
            className="relative py-20 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1423666639041-f56000c27a9a?ixlib=rb-4.0.3&auto=format&fit=crop&w=2074&q=80)'
            }}
            data-component-path="client/src/pages/Contact.jsx" data-component-line="2:6" data-component-id="client/src/pages/Contact.jsx:2:6"
          >
            <div className="absolute inset-0 bg-black bg-opacity-60" data-component-path="client/src/pages/Contact.jsx" data-component-line="3:8" data-component-id="client/src/pages/Contact.jsx:3:8"></div>
            <div className="relative z-10 max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Contact.jsx" data-component-line="4:8" data-component-id="client/src/pages/Contact.jsx:4:8">
              <h1 className="text-5xl md:text-6xl font-bold text-white mb-6" data-component-path="client/src/pages/Contact.jsx" data-component-line="5:10" data-component-id="client/src/pages/Contact.jsx:5:10">Get In Touch</h1>
              <p className="text-xl text-gray-200" data-component-path="client/src/pages/Contact.jsx" data-component-line="6:10" data-component-id="client/src/pages/Contact.jsx:6:10">
                We'd love to hear from you. Send us a message and we'll respond as soon as possible.
              </p>
            </div>
          </section>

          {/* Contact Section */}
          <section className="py-20" data-component-path="client/src/pages/Contact.jsx" data-component-line="7:6" data-component-id="client/src/pages/Contact.jsx:7:6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Contact.jsx" data-component-line="8:8" data-component-id="client/src/pages/Contact.jsx:8:8">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-component-path="client/src/pages/Contact.jsx" data-component-line="9:10" data-component-id="client/src/pages/Contact.jsx:9:10">
                {/* Contact Information */}
                <div data-component-path="client/src/pages/Contact.jsx" data-component-line="10:12" data-component-id="client/src/pages/Contact.jsx:10:12">
                  <h2 className="text-3xl font-bold text-gray-900 mb-8" data-component-path="client/src/pages/Contact.jsx" data-component-line="11:14" data-component-id="client/src/pages/Contact.jsx:11:14">Contact Information</h2>
                  <p className="text-lg text-gray-600 mb-8" data-component-path="client/src/pages/Contact.jsx" data-component-line="12:14" data-component-id="client/src/pages/Contact.jsx:12:14">
                    Ready to start your next project? Contact us today and let's discuss how we can help 
                    bring your vision to life.
                  </p>

                  <div className="space-y-6" data-component-path="client/src/pages/Contact.jsx" data-component-line="13:14" data-component-id="client/src/pages/Contact.jsx:13:14">
                    {contactInfo.map((info, index) => (
                      <div key={index} className="flex items-start space-x-4" data-component-path="client/src/pages/Contact.jsx" data-component-line="14:16" data-component-id="client/src/pages/Contact.jsx:14:16">
                        <div className="flex-shrink-0" data-component-path="client/src/pages/Contact.jsx" data-component-line="15:18" data-component-id="client/src/pages/Contact.jsx:15:18">
                          {info.icon}
                        </div>
                        <div data-component-path="client/src/pages/Contact.jsx" data-component-line="16:18" data-component-id="client/src/pages/Contact.jsx:16:18">
                          <h3 className="text-lg font-semibold text-gray-900" data-component-path="client/src/pages/Contact.jsx" data-component-line="17:20" data-component-id="client/src/pages/Contact.jsx:17:20">{info.title}</h3>
                          <a 
                            href={info.link}
                            className="text-gray-600 hover:text-blue-600 transition-colors"
                            data-component-path="client/src/pages/Contact.jsx" data-component-line="18:20" data-component-id="client/src/pages/Contact.jsx:18:20"
                          >
                            {info.details}
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Contact Form */}
                <div className="bg-white rounded-xl shadow-lg p-8" data-component-path="client/src/pages/Contact.jsx" data-component-line="19:12" data-component-id="client/src/pages/Contact.jsx:19:12">
                  <h2 className="text-3xl font-bold text-gray-900 mb-8" data-component-path="client/src/pages/Contact.jsx" data-component-line="20:14" data-component-id="client/src/pages/Contact.jsx:20:14">Send us a Message</h2>
                  
                  <form onSubmit={handleSubmit} className="space-y-6" data-component-path="client/src/pages/Contact.jsx" data-component-line="21:14" data-component-id="client/src/pages/Contact.jsx:21:14">
                    <div data-component-path="client/src/pages/Contact.jsx" data-component-line="22:16" data-component-id="client/src/pages/Contact.jsx:22:16">
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="23:18" data-component-id="client/src/pages/Contact.jsx:23:18">
                        Full Name
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                        placeholder="Your full name"
                        data-component-path="client/src/pages/Contact.jsx" data-component-line="24:18" data-component-id="client/src/pages/Contact.jsx:24:18"
                      />
                    </div>

                    <div data-component-path="client/src/pages/Contact.jsx" data-component-line="25:16" data-component-id="client/src/pages/Contact.jsx:25:16">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="26:18" data-component-id="client/src/pages/Contact.jsx:26:18">
                        Email Address
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                        placeholder="your.email@example.com"
                        data-component-path="client/src/pages/Contact.jsx" data-component-line="27:18" data-component-id="client/src/pages/Contact.jsx:27:18"
                      />
                    </div>

                    <div data-component-path="client/src/pages/Contact.jsx" data-component-line="28:16" data-component-id="client/src/pages/Contact.jsx:28:16">
                      <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="29:18" data-component-id="client/src/pages/Contact.jsx:29:18">
                        Subject
                      </label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                        placeholder="What's this about?"
                        data-component-path="client/src/pages/Contact.jsx" data-component-line="30:18" data-component-id="client/src/pages/Contact.jsx:30:18"
                      />
                    </div>

                    <div data-component-path="client/src/pages/Contact.jsx" data-component-line="31:16" data-component-id="client/src/pages/Contact.jsx:31:16">
                      <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="client/src/pages/Contact.jsx" data-component-line="32:18" data-component-id="client/src/pages/Contact.jsx:32:18">
                        Message
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        rows={6}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors resize-none"
                        placeholder="Tell us more about your project..."
                        data-component-path="client/src/pages/Contact.jsx" data-component-line="33:18" data-component-id="client/src/pages/Contact.jsx:33:18"
                      />
                    </div>

                    <button
                      type="submit"
                      className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2"
                      data-component-path="client/src/pages/Contact.jsx" data-component-line="34:16" data-component-id="client/src/pages/Contact.jsx:34:16"
                    >
                      <Send className="h-5 w-5" data-component-path="client/src/pages/Contact.jsx" data-component-line="35:18" data-component-id="client/src/pages/Contact.jsx:35:18" />
                      <span data-component-path="client/src/pages/Contact.jsx" data-component-line="36:18" data-component-id="client/src/pages/Contact.jsx:36:18">Send Message</span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      )
    }

    export default Contact